import { brightpathTheme } from '@youscience/theme';

export const sxStyles = {
  pageWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  accordionDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    padding: '0.75rem 0.5rem',
  },
  flexWrap: {
    display: 'flex',
    gap: '1rem',
  },
  link: {
    color: brightpathTheme.palette.secondary.main,
    textDecorationColor: brightpathTheme.palette.secondary.main,
  },
};
